import { render, staticRenderFns } from "./recommended-goods-skeleton.vue?vue&type=template&id=791c2892&scoped=true&lang=pug&"
import script from "./recommended-goods-skeleton.vue?vue&type=script&lang=js&"
export * from "./recommended-goods-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./recommended-goods-skeleton.vue?vue&type=style&index=0&id=791c2892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c2892",
  null
  
)

export default component.exports